import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "@app2/shared/shared.module";
import { WatchlistPersonNameComponent } from "@app2/watchlists/watchlist-person-name.component";
import { AddIndicatorsReasonComponent } from "@app2/watchlists/add-indicators-reason.component";
import { FormsModule } from "@angular/forms";

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
    ],
    declarations: [
        AddIndicatorsReasonComponent,
        WatchlistPersonNameComponent,
    ],
    exports: [
        AddIndicatorsReasonComponent,
        WatchlistPersonNameComponent,
    ]
})
export class WatchlistsSharedModule {
}